export const STATUSES_WITH_CUSTOMER_NEEDED = ['Installed', 'Sold', 'New'];

export const STATUSES_WITH_CUSTOMER_NOT_MANDATORY = ['Used', 'Written Off'];

export const IPAD_MEDIA_QUERY_WIDTH = '(max-width:1025px)';
export const MOBILE_MEDIA_QUERY_WIDTH = '(max-width:500px)';
